<template>
    <div>
        <v-card elevation="3" class="mx-auto" max-width="780px">
            <v-card elevation="0" color="#004236" class="white--text">
                <v-row>
                    <v-col md="8">
                        <v-card-title>Register new Account</v-card-title>
                        <v-card-subtitle>
                            All information entered in below form will be kept safe and confidential. <br />
                            If you have any concerns or issues, please contact King's HR via <a href="mailto:HR@kings.uwo.ca" style="color: white;">HR@kings.uwo.ca</a> or call at 519-433-3491.
                        </v-card-subtitle>
                    </v-col>
                    <v-col md="3" class="align-content-end">
                        <v-img src="../../../assets/background/KingsLogoinWhite.png" class="ma-2" width="200"></v-img>
                    </v-col>
                </v-row>
            </v-card>
            <br /><v-spacer></v-spacer>
            <v-card-text>
                <v-row>
                    <v-col
                        md="6"
                    >
                        <v-text-field
                            label="First Name"
                            v-model="newUser.firstname"
                            outlined
                            :rules="[rules.required]"
                            @keyup="formValidation"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        md="6"
                    >
                        <v-text-field
                            label="Last Name"
                            v-model="newUser.lastname"
                            outlined
                            :rules="[rules.required]"
                            @keyup="formValidation"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        md="12"
                    >
                        <v-text-field
                            label="Email"
                            v-model="newUser.email"
                            placeholder="The email address you enter will be your username."
                            outlined
                            hint="Please do not use your Western email address."
                            :rules="[rules.required, rules.email, rules.westernemail]"
                            persistent-hint
                            @keyup="formValidation"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        md="12"
                    >
                        <v-text-field
                            v-model="newUser.password"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.min]"
                            :type="show1 ? 'text' : 'password'"
                            label="Password"
                            @click:append="show1 = !show1"
                            outlined
                            @keyup="formValidation"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                        <v-col
                            md="12"
                        >
                            <span>Below fields are needed to identify you more precisely. They will not be used for any non-identification purposes.</span>
                        </v-col>
                        <v-col
                            md="2"
                        >
                            Phone Number
                        </v-col>
                        <v-col
                            md="5"
                        >
                            <v-text-field
                                label="Phone Number"
                                v-model="newUser.phone"
                                :rules="[rules.required, rules.number]"
                                outlined
                                @keyup="formValidation"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            md="2"
                        >
                            Last 4 digits of your SIN
                        </v-col>
                        <v-col
                            md="3"
                        >
                            <v-text-field
                                v-model="newUser.last4sin"
                                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.sin]"
                                :type="show2 ? 'text' : 'password'"
                                label="Last 4 digits"
                                counter="4"
                                outlined
                                @click:append="show2 = !show2"
                                @keyup="formValidation"
                            ></v-text-field>
                        </v-col>
                </v-row>
                <br /><v-divider></v-divider><br />
                <v-row>
                    <v-col cols="3"></v-col><v-col cols="3"></v-col><v-col cols="3"></v-col>
                    <v-col cols="3" class="d-flex justify-end mb-6">
                        <!--Dialog to confirm registeration-->
                        <v-row justify="end">
                            <v-dialog
                                v-model="dialog"
                                persistent
                                max-width="450"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="#004236"
                                        style="color: white;"
                                        :disabled="regbtndisable"
                                        class="ma-2"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        Register
                                    </v-btn>
                                </template>
                                <v-card>
                                    <form @submit.prevent="userRegisteration">
                                        <v-card-title class="text-h5">Confirm to Register</v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-subtitle>
                                            Please make sure that you have entered correct information. A confirmation email will be sent upon registration to verify your account.
                                        </v-card-subtitle>
                                        <v-card-text>
                                                <v-row>
                                                    <v-col md="3">Email: </v-col>
                                                    <v-col md="9">{{ newUser.email }}</v-col>
                                                    <v-col md="3">Name: </v-col>
                                                    <v-col md="9">{{ newUser.firstname + " " + newUser.lastname }}</v-col>
                                                    <v-col md="3">Phone: </v-col>
                                                    <v-col md="9">{{ newUser.phone }}</v-col>
                                                </v-row>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="green darken-1"
                                                text
                                                @click="dialog = false"
                                            >
                                                Go back
                                            </v-btn>
                                            <v-btn
                                                color="green darken-1"
                                                text
                                                type="submit"
                                                :loading="loading"
                                                :disabled="loading"
                                            >
                                                Register
                                            </v-btn>
                                        </v-card-actions>
                                    </form>
                                </v-card>
                            </v-dialog>
                        </v-row>
                        <!--Dialog to confirm registeration Finished-->
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!--Dialog shown after sending confirmation email-->
        <v-dialog
            v-model="dialog2"
            persistent
            max-width="550"
        >
            <v-card>
                <v-card-title class="text-h5">
                    Confirmation Email Sent
                </v-card-title>
                <v-card-text>
                    A confirmation email with the verification link is sent to {{ newUser.email }}. <br />
                    <b>Please activate your account before signing in.</b> If you haven't received the email, please wait for a few minutes or check your spam.<br />
                    If you do not get an email within 10 minutes, please go back to the sign in page and click 'Verify Email' button to follow next steps.
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="green darken-1"
                        to="/signin"
                        dark
                        block
                    >
                        Sign In Now
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import firebase from 'firebase'
require('firebase/auth')

export default {
    data(){
        return {
            host: location.hostname.toString(),
            newUser: {
                firstname: "",
                lastname: "",
                email: "",
                password: "",
                last4sin: "",
                phone: ""
            },
            show1: false,
            rules: {
                required: value => !!value || 'Required Field.',
                email: v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Invalid email format",
                westernemail: v=> !(/uwo.ca$/.test(v)) || "Please do not use western email",
                min: v => v.length >= 10 || 'Min 10 characters',
                number: v=> /^[0-9]*$/.test(v) || "Numbers only",
                sin: v=> /^\d{4}$/.test(v) || "4 digit number"
            },
            show2: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            loading: false,
            dialog: false,
            dialog2: false,
            regbtndisable: true
        }
    },
    methods: {
        formValidation(){
            const that = this;
            if(
                //Regex checks (first row for name fields, second row for email checks & second row for rest of the form fields)
                that.newUser.firstname != "" && that.newUser.lastname != "" &&
                /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(that.newUser.email) && !(/uwo.ca$/.test(that.newUser.email)) && 
                that.newUser.password.length >= 10 && /^[0-9]*$/.test(that.newUser.phone) && /^\d{4}$/.test(that.newUser.last4sin)
            ){
                that.regbtndisable = false;
            }else {
                that.regbtndisable = true;
            }
        },
        userRegisteration(){
            const that = this;
            that.dialog2 = false;
            that.loading = true;
            firebase.auth()
                .createUserWithEmailAndPassword(that.newUser.email, that.newUser.password)
                .then((res)=>{
                    res.user
                        .updateProfile({
                            displayName : that.newUser.firstname+ " " +that.newUser.lastname
                        })
                        .then(()=>{
                            const currentUser = firebase.auth().currentUser;
                            var user = {
                                firstname: that.newUser.firstname,
                                lastname: that.newUser.lastname,
                                email: that.newUser.email,
                                phone: {
                                    home: "",
                                    cell: that.newUser.phone
                                },
                                lastsin: that.newUser.last4sin,
                                department: "applicant",
                                uid: currentUser.uid,
                                preferredemail: "email"
                            }
                            
                            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

                            const formData = new FormData();

                            formData.append("mode", "initAccount");
                            formData.append("data", JSON.stringify(user));

                            //API calling
                            fetch(api,{
                                method: "POST",
                                body: formData
                            })
                                .then(function (response) {
                                    return response.json();
                                })
                                .then(function (resultData) {
                                    if(!resultData.result.match(/^OK/i)){
                                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                                    }else {
                                        currentUser.sendEmailVerification();
                                        that.loading = false;
                                        that.dialog=false;
                                        that.dialog2= true;
                                    }
                                })
                                .catch(function(err){
                                    that.loading = false;
                                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                                })
                            //End of API calling
                            
                        });
                })
                .catch((err)=>{
                    this.setSnackbar(err, "#E53935");
                    that.loading = false;
                });
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    }
}
</script>
